import React, { FC, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface IProps {
  open: boolean;
  children: React.ReactNode;
}

/** Nested dialogs share one body lock; only unlock when the last open dialog closes. */
let bodyScrollLockCount = 0;

const lockBodyScroll = () => {
  bodyScrollLockCount += 1;
  document.body.style.overflow = 'hidden';
};

const unlockBodyScroll = () => {
  bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);
  if (bodyScrollLockCount === 0) {
    document.body.style.overflow = '';
  }
};

const DialogLayout: FC<IProps> = props => {
  const { open, children } = props;

  useEffect(() => {
    if (!open) {
      return;
    }

    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, [open]);

  return ReactDOM.createPortal(
    <>
      {open && (
        <div className='fixed w-full h-full left-0 top-0 bg-[#000000A8] z-20'>
          <div className='h-full flex justify-center items-center'>
            {children}
          </div>
        </div>
      )}
    </>,
    document.getElementById('popups')!
  );
};

export default DialogLayout;
